const { axios, API_URL, generateHeaders, queryParamsToPathParams } = require('./helper');

/**
 * @description returns a family accums object for a specific product and year
 * @param {String} employeeId the JV employeeId
 * @param {String} product Product ID - M=Medical, D=Dental, V=Vision, P-Perscription, H=HSA
 * @param {String} year Year - 2017, 2018, etc.
 * @param {int} depSeqNum Dependent Sequence Number
 */

const getFamilyAccums = async (employeeId, product, year, depSeqNum) => {
    const params = {
        employeeid: employeeId,
        product: product,
        year: year,
        depsequencenumber: depSeqNum
    }
    let url = queryParamsToPathParams(params, `${API_URL}pureProxy/eligibility/memberaccumulators`);
    const response = await axios.get(url, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

module.exports = {
    getFamilyAccums
};